import { ReactNode } from 'react'

import styles from './PageHeader.module.scss'

interface PageHeaderProps {
  action?: ReactNode
  description: string
  title: string
}

const PageHeader = ({ action, description, title }: PageHeaderProps) => (
  <header className={styles.pageHeader}>
    <div>
      <h1>{title}</h1>
      <p>{description}</p>
    </div>
    {action}
  </header>
)

export default PageHeader
